const { arCitiesRegions, enCitiesRegions } = require("@/constants/branches");
const { useRouter } = require("next/router");
const { useMemo } = require("react");

const useCitySearch = ({ regionId, cityId, locatorsData }) => {
  const { locale } = useRouter();
  const filteredLocatorsData = useMemo(() => {
    if (regionId && cityId) {
      return locatorsData?.filter((item) => {
        return item.city === regionId && item.address.includes(cityId);
      });
    }
    if (regionId) {
      return locatorsData?.filter((item) => {
        return item.city === regionId;
      });
    }
    return locatorsData;
  }, [locatorsData, regionId, cityId]);
  const getCorrectRegionCities = useMemo(() => {
    return regionId
      ? locale === "ar"
        ? arCitiesRegions[regionId]
        : enCitiesRegions[regionId]
      : [];
  }, [locale, regionId]);

  const regionsOptions =
    locale === "ar"
      ? Object.keys(arCitiesRegions).map((key) => ({ label: key, value: key }))
      : Object.keys(enCitiesRegions).map((key) => ({ label: key, value: key }));

  const citiesOptions = useMemo(
    () =>
      getCorrectRegionCities?.map((city) => ({
        value: city,
        label: city,
      })),
    [getCorrectRegionCities]
  );

  return {
    filteredLocatorsData,
    citiesOptions,
    regionsOptions,
  };
};

export default useCitySearch;
